// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { Gallery } from '../_components/Gallery';
import { ImageWithCaption } from '../_components/ui';
import { prepareImage } from '../_filters';
import { GalleryVersion } from './Gallery.contracts';
/**
 * Component capable of rendering the `GalleryModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let GalleryModuleUi = class GalleryModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Images to be included in the slider (gallery).
         */
        this.images = [];
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        try {
            const images = await this.relatedService.resolve(this.module.content.gallery);
            this.images = (Array.isArray(images) ? images : [images]);
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    /**
     * Determines whether the module should be running in the "carousel" version.
     */
    get isCarousel() {
        return this.module.version !== GalleryVersion.Stack;
    }
};
GalleryModuleUi = __decorate([
    Component({
        name: 'GalleryModuleUi',
        components: { ImageWithCaption, Gallery },
        filters: { prepareImage },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="gallery-module" :class="[debugClass, loadingClass]">
      <!-- GalleryVersion.Carousel -->
      <Gallery v-if="isCarousel" v-bind="{ images, windowService }" />

      <!-- GalleryVersion.Stack -->
      <ol v-else class="gallery-module__stack row list-unstyled">
        <li v-for="(image, index) in images" :key="image.id" class="gallery-module__stack__item col-12">
          <p class="gallery-module__stack__item__heading">
            <b role="presentation">{{ index + 1 }} {{ $t('_.of') }} {{ images.length }}</b> {{  }}
          </p>
          <ImageWithCaption :image="image | prepareImage" class="gallery-module__stack__item__image" />
        </li>
      </ol>
    </section>
  `
    })
], GalleryModuleUi);
export { GalleryModuleUi };
